// Seasonal logo utility for RSX Concept
// Returns the appropriate logo URL based on the current date

const DEFAULT_LOGO = "https://customer-assets.emergentagent.com/job_mocktail-hub-6/artifacts/yiexn6qe_Simple%20Modern%20Minimalist%20Circle%20Design%20Studio%20Logo.png";

const SEASONAL_LOGOS = {
  newyear: '/logos/seasonal/newyear.png',
  valentine: '/logos/seasonal/valentine.png',
  grandmothers: '/logos/seasonal/grandmothers.png',
  mothers: '/logos/seasonal/mothers.png',
  fathers: '/logos/seasonal/fathers.png',
  christmas: '/logos/seasonal/christmas.png',
};

function getSeasonalLogo() {
  const now = new Date();
  const month = now.getMonth() + 1; // 1-12
  const day = now.getDate();

  // Nouvel An: 1-7 janvier
  if (month === 1 && day <= 7) return SEASONAL_LOGOS.newyear;

  // Saint-Valentin: 1-14 février
  if (month === 2 && day <= 14) return SEASONAL_LOGOS.valentine;

  // Fête des Grands-Mères: 1er dimanche de mars (~1-8 mars)
  if (month === 3 && day <= 8) return SEASONAL_LOGOS.grandmothers;

  // Fête des Mères: dernier dimanche de mai (~20 mai - 2 juin)
  if ((month === 5 && day >= 20) || (month === 6 && day <= 2)) return SEASONAL_LOGOS.mothers;

  // Fête des Pères: 3e dimanche de juin (~10-22 juin)
  if (month === 6 && day >= 10 && day <= 22) return SEASONAL_LOGOS.fathers;

  // Noël: tout décembre
  if (month === 12) return SEASONAL_LOGOS.christmas;

  // Par défaut
  return DEFAULT_LOGO;
}

export { getSeasonalLogo, DEFAULT_LOGO, SEASONAL_LOGOS };
